import {useQuery} from '@tanstack/react-query'
import api, {CameraInclude, CameraOriginType} from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  selectedCompanies?: number[]
  clientIds?: number[]
  originsToFilter?: CameraOriginType[]
  includes?: CameraInclude[]
  enabled?: boolean
}

export default function useCameras({selectedCompanies, originsToFilter, clientIds, includes, enabled = true}: Props) {
  const query = useQuery({
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.CAMERAS, selectedCompanies, clientIds],
    enabled,
    queryFn: async () =>
      await api.camera.getMany({
        paginate: false,
        filter: {
          companyIds: selectedCompanies,
          origin: originsToFilter,
          clientIds,
        },
        includes,
      }),
  })

  return query
}
